// Call this method to get an env variable during build time.
// Don't use this in runtime, because {process.env} is not available in runtime.
export const getEnvVariable = (key: EnvironmentVariableKey, defaultValue?: EnvironmentVariableValue): EnvironmentVariableValue => {
  const envVariable = process.env[key];

  if (!envVariable) {
    if (defaultValue) {
      return defaultValue;
    }

    throw new Error(`Environment variable ${ key } is not defined and no default value is provided.`);
  }

  return envVariable;
};